import { useSelector } from 'react-redux';
import ImageLoader from '../../../ImageLoader';

const LoyaltyPoint = (props) => {
	const { payment, index, values, setValues, paymentSummary } = props;  
	const { loyalty } = useSelector((store) => store?.loyalty);
  const isLowBalance = Number(loyalty?.point || 0) < paymentSummary?.totalPayment

	return (
		<div
			id={payment?.event}
			key={`payment_${index}`}
			className={`border-1 border-gray-300 border-solid rounded-md flex justify-between px-2 py-2.5 mt-2 items-center min-h-14`}
			onClick={() => {
        if (isLowBalance) return;
				setValues((prev) => {
					return {
						...prev,
						paymentType: payment,
					};
				});
			}}>
			<div className='flex items-center'>
				<ImageLoader alt={payment?.alt ?? ''} src={payment?.image_url} className={payment?.image_size || 'w-9 h-auto max-h-9'} />
				<div className='pl-2'>
					<div className={`text-xs capitalize font-semibold text-gray-900`}>{`${payment?.name}`}</div>
					<div className={`text-xs capitalize font-normal text-[var(--rose-violet)]`}>
						{new Intl.NumberFormat('id-ID').format(loyalty?.point || 0)}
						{' '} Point
					</div>
					{isLowBalance && <div className={`text-xxs pt-1 font-thin text-red-700`}>Saldo Anda tidak mencukupi</div>}
				</div>
			</div>
			<div className='flex flex-row items-center'>
				<div className='pl-2'>
					<input
						id='payment'
						type='radio'
						name='payment'
						value={payment?.code}
						checked={values?.paymentType?.code === payment?.code}
						onChange={() => null}
						className={`${values?.paymentType?.code === payment?.code ? '!border-[var(--rose-violet)]' : '!border-gray-400'} after:!bg-[var(--rose-violet)] active:bg-white focus:bg-transparent`}
					/>
				</div>
			</div>
		</div>
	);
};

const ListPaymentMethod = (props) => {
	const { method = {}, values = {}, setValues = () => {} } = props;
	return (
		<div className='w-full'>
			<div className='flex justify-start py-4 text-sm text-gray-800 font-semibold capitalize'>{method?.category ?? ''}</div>
			{method?.payment_method?.map((payment, index) => {
				const isLoyaltyPoint = payment?.code === 'LOYALTY';

				if (isLoyaltyPoint) {
					return <LoyaltyPoint key={`payment_${index}`} {...{ payment, ...props }} />;
				}

				return (
					<div
						id={payment?.event}
						key={`payment_${index}`}
						className={`border-1 border-gray-300 border-solid rounded-md flex justify-between px-2 py-2.5 mt-2 items-center min-h-14`}
						onClick={() => {
							setValues((prev) => {
								return {
									...prev,
									paymentType: payment,
								};
							});
						}}>
						<div className='flex items-center'>
							<ImageLoader alt={payment?.alt ?? ''} src={payment?.image_url} className={payment?.image_size || 'w-9 h-auto max-h-9'} />
							<div className='pl-2'>
								<div className={`text-xs capitalize font-semibold text-gray-900`}>{`${payment?.name}`}</div>
							</div>
						</div>
						<div className='flex flex-row items-center'>
							<div className='pl-2'>
								<input
									id='payment'
									type='radio'
									name='payment'
									value={payment?.code}
									checked={values?.paymentType?.code === payment?.code}
									onChange={() => null}
									className={`${values?.paymentType?.code === payment?.code ? '!border-[var(--rose-violet)]' : '!border-gray-400'} after:!bg-[var(--rose-violet)] active:bg-white focus:bg-transparent`}
								/>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default ListPaymentMethod;
